import React, { FC } from 'react'
import Tag from '@vtex/styleguide/lib/Tag'
import { CustomPriceProps } from '../ProductSummary'
import PriceDetail from './PriceDetail'
import IntlMessages from './IntlMessage'
import BoldPrice from './BoldPrice'

type Props = {
  prices: CustomPriceProps[]
  intl: any
  index: number
}
const PromotionalPrice: FC<Props> = ({ prices, intl, index }) => {
  const totalPrice = prices.reduce((acc, { quantity, price }) => {
    return acc + quantity * price
  }, 0)

  return (
    <div className="flex flex-column">
      <div className="flex items-center mb3-s mb0-ns">
        <div
          id={`productlistitem-${index}-price`}
          className="flex items-center"
        >
          <BoldPrice value={totalPrice} />
        </div>
        <div className="flex items-center ml3">
          <Tag type="success" size="small">
            {intl.formatMessage(IntlMessages.promotionalLabel)}
          </Tag>
        </div>
      </div>
      <PriceDetail prices={prices} intl={intl} />
    </div>
  )
}

export default PromotionalPrice
